/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_CompareInputs */

const en_mk_foot_compare = /** @type {(inputs: Mk_Foot_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare`)
};

const id_mk_foot_compare = /** @type {(inputs: Mk_Foot_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan`)
};

/**
* | output |
* | --- |
* | "Compare" |
*
* @param {Mk_Foot_CompareInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_compare = /** @type {((inputs?: Mk_Foot_CompareInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CompareInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_compare(inputs)
	return en_mk_foot_compare(inputs)
});